<div class="search-row">
    <img class="preffix" src="../../../assets/icons/search.svg"
        (click)="emitSearchValue()">
    <input 
        [class]="size" 
        [placeholder]="placeholder" 
        type="text" 
        [(ngModel)]="searchQuery"
        (change)="emitSearchValue()">
    <img 
        *ngIf="searchQuery.length > 0" 
        class="suffix" 
        src="../../../assets/icons/close-x.svg"
        (click)="clearSearch()">
</div>